import React, { useState } from 'react';

function ImageViewer({ images, isOpen, onClose, initialIndex = 0 }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  if (!isOpen || !images || images.length === 0) return null;

  const currentImage = images[currentIndex];

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    } else if (e.key === 'ArrowLeft') {
      goToPrevious();
    } else if (e.key === 'ArrowRight') {
      goToNext();
    }
  };

  return (
    <div 
      className="modal fade show d-block" 
      style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}
      tabIndex="-1"
      onKeyDown={handleKeyDown}
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content bg-dark text-white">
          <div className="modal-header border-0">
            <h5 className="modal-title">
              Image {currentIndex + 1} of {images.length}
            </h5>
            <button 
              type="button" 
              className="btn-close btn-close-white" 
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body text-center p-0">
            <div className="position-relative">
              <img 
                src={currentImage.image_url || currentImage} 
                alt={`Image ${currentIndex + 1}`}
                className="img-fluid"
                style={{ maxHeight: '70vh', objectFit: 'contain' }}
              />
              
              {/* Navigation buttons */}
              {images.length > 1 && (
                <>
                  <button 
                    className="btn btn-outline-light position-absolute top-50 start-0 translate-middle-y ms-3"
                    onClick={goToPrevious}
                    style={{ zIndex: 1000 }}
                  >
                    ‹
                  </button>
                  <button 
                    className="btn btn-outline-light position-absolute top-50 end-0 translate-middle-y me-3"
                    onClick={goToNext}
                    style={{ zIndex: 1000 }}
                  >
                    ›
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="modal-footer border-0 justify-content-center">
            <div className="d-flex gap-2">
              {images.map((_, index) => (
                <button
                  key={index}
                  className={`btn btn-sm ${index === currentIndex ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setCurrentIndex(index)}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImageViewer; 